import React from 'react';
import { Input } from 'antd';
interface NumericInputProps {
  style: React.CSSProperties;
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
}

const NumericInput = (props: NumericInputProps) => {
  const { value, onChange, placeholder } = props;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value: inputValue } = e.target;
    const reg = /^-?\d*(\.\d*)?(,\s*-?\d*(\.\d*)?)*$/;
    if (reg.test(inputValue) || inputValue === '' || inputValue === ',') {
      onChange(inputValue);
    }
  };

  const handleBlur = () => {
    let valueTemp = value;
    if (value.charAt(value.length - 1) === '.' || value === ',') {
      valueTemp = value.slice(0, -1);
    }
    onChange(valueTemp.replace(/0*(\d+)/, '$1'));
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const text = e.clipboardData.getData('text/plain');
    const reg = /^-?\d*(\.\d*)?(,\s*-?\d*(\.\d*)?)*$/;
    if (reg.test(text) || text === '' || text === ',') {
      onChange(text);
    }
  };

  return (
    <Input
      style={props.style}
      value={props.value}
      onChange={handleChange}
      onBlur={handleBlur}
      onPaste={handlePaste}
      placeholder={placeholder}
    />
  );
};

export default NumericInput;
